import { JwtAxios, MarketingJwtAxios } from '@/packaging';

export const collectApi = {
  async GetCollectGroupNameList(site) {
    const responseModel = await JwtAxios.get(`/Collect/GetCollectGroupNameList?site=` + site);
    return responseModel;
  },
  async SetCollectGroup(model) {
    const responseModel = await JwtAxios.post(`/Collect/SetCollectGroup`, model);
    return responseModel;
  },
  async GetCollectGroupList(model) {
    const responseModel = await JwtAxios.post(`/Collect/GetCollectGroupList`, model);
    return responseModel;
  },
  async GetCollectGroup(groupName) {
    const responseModel = await JwtAxios.get(`/Collect/GetCollectGroup?groupName=${groupName}`);
    return responseModel;
  },
  async GetLastCollectGroup(model) {
    const responseModel = await JwtAxios.get('/Collect/GetLastCollectGroup', model);
    return responseModel;
  },
  async RemoveCollectGroup(model) {
    const responseModel = await JwtAxios.delete(`/Collect/RemoveCollectGroup`, model);
    return responseModel;
  },
  async DoCollect(id, model) {
    // model에 workId가 포함되어 있으면 함께 전송
    const responseModel = await JwtAxios.post(`/Collect/DoCollect?id=${id}`, model);
    return responseModel;
  },
  async GetCollectFailLog(model) {
    const responseModel = await JwtAxios.post(`/Collect/GetCollectFailLog`, model);
    return responseModel;
  },
  async uploadCollect(id, guid) {
    const responseModel = await JwtAxios.post(`/Market/DoProductUploadByCollect?id=${id}&guid=${guid}`);
    return responseModel;
  },
  async UpdateCollectGroup(guid, body) {
    const res = await JwtAxios.patch(`/Collect/UpdateCollectGroup?guid=${guid}`, body);
    return res;
  },
  async UpdateCollectCategoryGroup(guid, body) {
    const res = await JwtAxios.patch(`/Collect/UpdateCollectGroupCategory?guid=${guid}`, body);
    return res;
  },
  async updateBrandCollectGroup(id, body) {
    const res = await JwtAxios.post(`/Collect/LuxItemListInsert?id=${id}`, body);
    return res;
  },
  async VulkUpdateCollectGroup(model) {
    const responseModel = await JwtAxios.patch('/Collect/VulkUpdateCollectGroup', model);
    return responseModel;
  },
  async SearchNaverAdvertiseKeyword(model) {
    const responseModel = await JwtAxios.get('/Collect/SearchNaverAdvertiseKeyword', model);
    return responseModel;
  },
  async SearchNaverShoppingKeyword(model) {
    const responseModel = await JwtAxios.get('/Collect/SearchNaverShoppingKeyword', model);
    return responseModel;
  },
  async VulkDelete(body) {
    const res = await JwtAxios.delete('/Collect/VulkDelete', body);
    return res;
  },
  async deleteCollectTask(Id, sessionType = 'current') {
    const res = await JwtAxios.post('/Collect/RemoveAllCollect?id=' + Id + '&sessionType=' + sessionType);
    return res;
  },
  async deleteTask(Id, menuurl, selectedServer, sessionType = 'current') {
    const res = await JwtAxios.post('/Collect/RemoveAllCollect?id=' + Id + '&menuurl=' + menuurl + '&serverNo=' + selectedServer + '&sessionType=' + sessionType);
    return res;
  },
  async VulkCollect(id, body) {
    const res = await JwtAxios.post(`/Collect/VulkCollect?id=${id}`, body);
    return res;
  },
  async TextTranslate(connectionId, body) {
    const res = await JwtAxios.post(`/Collect/TextTranslate?connectionId=${connectionId}`, body);
    return res;
  },
  async GetUrlUploadExcelTemplate() {
    const res = await JwtAxios.excelMultiPartGet(`/Collect/GetUrlUploadExcelTemplate`);
    return res;
  },
  async GetRecommendKeywordList(domain) {
    const res = await MarketingJwtAxios.get(`/Collect/GetRecommendKeywordList?domain=${domain}`);
    return res;
  },
  /** 네이버 DataLab(쇼핑인사이트 등) 조건 조합 조회 — 마케팅 서버(VUE_APP_TEST_MARKETTING_API_URL) */
  async GetRecommendKeywordNaverDataLab(body) {
    const res = await MarketingJwtAxios.post(`/Collect/GetRecommendKeywordNaverDataLab`, body);
    return res;
  },
  async GetHtmlImages(connectionId, url) {
    const res = await JwtAxios.get(`/Collect/GetHtmlImages?id=${connectionId}&url=${url}`);
    return res;
  },
  async SetManualCollectSetting(connectionId, model) {
    const res = await JwtAxios.post(`/Collect/SetManualCollectSetting?id=${connectionId}`, model);
    return res;
  },
  async GetUserCollectSites() {
    const res = await JwtAxios.get(`/Collect/GetUserCollectSites`);
    return res;
  },
  async getSsgUploadOption(account) {
    const res = await JwtAxios.get(`/Collect/GetSsgUploadOption?account=${account}`);
    return res;
  },
  async getGosiData(userid, marketAccount) {
    const res = await JwtAxios.get(`/Collect/GetGosiData?userid=${userid}&market=ssg&marketAccount=${marketAccount}`);
    return res;
  },
  async ReCollectProduct(productIds) {
    const res = await JwtAxios.post(`/Collect/ReCollectProduct`, productIds);
    return res;
  },
  async CreateCollectTag(model) {
    const res = await JwtAxios.post(`/Collect/CreateCollectTag`, model);
    return res;
  },
  async GetCollectTags(tagName) {
    const res = await JwtAxios.get(`/Collect/GetCollectTags?tagName=${encodeURIComponent(tagName || '')}`);
    return res;
  },
  async DeleteCollectTag(model) {
    const res = await JwtAxios.delete(`/Collect/DeleteCollectTag`,model);
    return res;
  },
  async UpdateCollectTagOrder(model) {
    // dbIdx가 있으면 쿼리 파라미터로 추가
    let url = `/Collect/UpdateCollectTagOrder`;
    if (model.dbIdx !== undefined) {
      url += `?dbIdx=${model.dbIdx}`;
    }
    // body에는 tagOrders만 전송 (userId는 JWT에서 추출)
    const body = {
      tagOrders: model.tagOrders
    };
    const res = await JwtAxios.post(url, body);
    return res;
  },
  async RequestAiImagePriority(model) {
    const res = await JwtAxios.post(`/Collect/RequestAiImagePriority`, model);
    return res;
  },
  async GetAiImagePriorityList() {
    const res = await JwtAxios.get(`/Collect/GetAiImagePriorityList`);
    return res;
  },
  async DeleteAiImagePriority(idx) {
    const res = await JwtAxios.delete(`/Collect/DeleteAiImagePriority?idx=${idx}`);
    return res;
  },
  async UpdateAiImagePriorityOrder(orderList) {
    const res = await JwtAxios.post(`/Collect/UpdateAiImagePriorityOrder`, orderList);
    return res;
  }
};
